module.exports = ":host ::ng-deep {\n  position: absolute;\n  right: 0;\n  display: block;\n  width: 100%;\n  top: 36px;\n  left: calc(100% + 5px); }\n  :host ::ng-deep .icons {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/sortable-placeholder/sortable-placeholder.component.scss
// module id = ./src/app/shared/components/sortable-placeholder/sortable-placeholder.component.scss
// module chunks = main